<template>
  <div style="flex:1;">
    <v-chart
        :forceFit="true"
        :height="height"
        :data="chartData"
        padding="auto"
        :scale="{dataKey:'Quantity',alias: lang === 'en' ? 'Quantity' : '数量'}"
    >
      <v-coord type="rect" direction="LB" />
      <v-tooltip />
      <v-axis dataKey="item" :label="label" />
<!--      <v-bar position="item*Quantity" :label="['Quantity',(val) => {return {content: val}}]"/>-->
      <v-bar position="item*Quantity"/>
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set');

const createChartData = (originalData)=>{
  
  if(!originalData) return []

  const sourceData = []
  
  for(let key in originalData){
      if(key !== 'endDate'){

        sourceData.push({item:key,'Quantity':originalData[key]})
      }
  }

const dv = new DataSet.View().source(sourceData);
dv.transform({
        type: 'sort',
        callback(a, b) {
          return a.value - b.value < 0;
        },
      });
const data = dv.rows;

  return data
}

const label = { offset: 12 };

export default {
  props:['originalData'],
  data() {
    return {
        height: 400,
        label: label,
      };
  },
  computed: {
    chartData(){
      return createChartData(this.originalData)
    },
    lang() {
      return this.$store.state.plang;
    },
  }
};
</script>